import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { forkJoin } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { FormatCurrencyPipe } from 'src/app/shared/pipes/formatCurrency.pipe';


@Component({
  selector: 'app-statistics-sales-graph',
  templateUrl: './statistics-sales-graph.component.html',
  styleUrls: ['./statistics-sales-graph.component.scss'],
  providers: [FormatCurrencyPipe]

})
export class StatisticsSalesGraphComponent implements OnInit {
  public isLoaded: boolean = false;
  chartOptions: any;

  constructor(private dashBoardService: DashboardService, private translate: TranslateService,
              private formatCurrency: FormatCurrencyPipe
  ) {}

  langSub!: Subscription;

  ngOnInit(): void {
    this.loadLastSales();

    this.langSub = this.translate.onLangChange.subscribe(() => {
    this.loadLastSales(); 
    }); 
  }

  private readonly monthMap: Record<string, string> = {
  'JAN.': 'months.jan', 'FEV.': 'months.feb', 'MAR.': 'months.mar',
  'ABR.': 'months.apr', 'MAI.': 'months.may', 'JUN.': 'months.jun',
  'JUL.': 'months.jul', 'AGO.': 'months.aug', 'SET.': 'months.sep',
  'OUT.': 'months.oct', 'NOV.': 'months.nov', 'DEZ.': 'months.dec'  
  };

  private translateMonths(ptLabels: string[]): string[] {
  return ptLabels.map(lab => {
    const key = this.monthMap[lab] ?? lab;
    return this.translate.instant(key);
  });
}

  loadLastSales(): void {
  this.isLoaded = true;

  forkJoin({
    lastYearSales: this.getLastYearSales(),
    lastYearReceivedSales: this.getLastYearReceivedSales(),
    lastYearWithdrawSales: this.getLastYearWithdrawSales(),
  }).subscribe({
    next: (results) => {
      const lastYearSales = results.lastYearSales;
      const lastYearReceivedSales = results.lastYearReceivedSales;
      const lastYearWithdrawSales = results.lastYearWithdrawSales;

      this.translate.get([
        'common.generatedDeposits',
        'common.receivedDeposits',
        'common.withdrawals'
      ]).subscribe((translations) => {

        const translatedLabels = this.translateMonths(lastYearReceivedSales.labels);

        this.loadMonthGraph(
          translatedLabels, 
          lastYearWithdrawSales.values,
          lastYearSales.values,
          lastYearReceivedSales.values,
          translations['common.generatedDeposits'],
          translations['common.receivedDeposits'],
          translations['common.withdrawals']
        );
      });
    },
    error: (error) => {
      console.error('Erro ao carregar os saldos', error);
    },
    complete: () => {
      this.isLoaded = false;
    },
  });
}

  getLastYearSales() {
    return this.dashBoardService.getLastYearSales().then((value) => {
      return value;
    });
  }

  getLastYearReceivedSales() {
    return this.dashBoardService.getLastYearReceivedSales().then((value) => {
      return value;
    });
  }

  getLastYearWithdrawSales() {
    return this.dashBoardService.getLastYearWithdrawSales().then((value) => {
      return value;
    });
  }

  loadMonthGraph(
    labels: string[],
    lastYearWithdrawSales: number[],
    lastYearSales: number[],
    lastYearReceivedSales: number[],
    labelGenerated: string,
    labelReceived: string,
    labelWithdrawals: string,
  ) {
    const fmt = (v: number) => this.formatCurrency.transform(v);

    const styles = getComputedStyle(document.documentElement);
    const chartPrimary = styles.getPropertyValue('--monthly-chart-primary').trim();
    const chartSecondary = styles.getPropertyValue('--monthly-chart-secondary').trim();
    const chartTertiary = styles.getPropertyValue('--monthly-chart-tertiary').trim();

    this.chartOptions = {
      series: [
        {
          name: labelWithdrawals,
          type: 'bar',
          data: lastYearWithdrawSales,
        },
        {
          name: labelGenerated,
          type: 'area',
          data: lastYearSales,
        },
        {
          name: labelReceived,
          type: 'line',
          data: lastYearReceivedSales,
        },
      ],
      colors: [chartPrimary, chartSecondary, chartTertiary],
      chart: {
        height: 350,
        type: 'bar',
      },

      dataLabels: {
        enabled: false,
      },
      stroke: {
        width: 3,
      },
      plotOptions: {
        bar: {
          columnWidth: '15%',
        },
      },
      yaxis: {
        labels: {
          formatter: fmt
        },
      },
      xaxis: {
        categories: labels,
      },
      tooltip: {
        shared: true,
        intersect: false,
        y: {
          formatter: fmt
        },
      },
      grid: {
        show: false,
      },
    };
  }
}
